import './chantiers.scss';
import '../../Inclusions/entetes/_entete.js';
import '../../Inclusions/pieds/_pied.js';
import '../../Inclusions/menus/_menu.js';

const select = document.querySelector('.chantier-select');
if (select) {
  select.addEventListener('change', () => {
    window.location.href = select.value;
  });
}
